module.exports = "<span class=\"fa-icon\">\n  <i class=\"{{ faClasses }}\"></i>\n</span>\n"